import React from 'react';
import { Product } from '../domain/product/product';
import { getBaseURL } from '../config/runtime';

export function ProductLinksDialog({ product }: { product: Product }) {
  const baseUrl = getBaseURL();
  return (
    <div className=" w-full max-w-2xl flex-col bg-white px-4 py-3 pb-6 rounded-b-md">
      <div className="mb-4 flex gap-x-4">
        <img
          src={`${baseUrl}/product/${product.id}/image?width=170`}
          alt={product.name}
          className="h-auto w-[170] rounded-sm"
        />
        <header>
          <h1 className="text-2xl font-bold text-gray-800">{product.name}</h1>
        </header>
      </div>
      <div>
        <label className="block text-lg font-semibold text-gray-800">
          Parameters
        </label>
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            <tr className="hover:!shadow-none">
              <td>loc</td>
              <td>
                The location which Rendivo will open in. If no location is
                specified then the location defaults to 'ALL'.
              </td>
            </tr>
            <tr className="hover:!shadow-none">
              <td>tags</td>
              <td>
                Meta-data in the form of tags can be passed with the request.
                Tags will be referenced in Analytics reports and data will be
                segregated based on passed tags.
              </td>
            </tr>
            <tr className="hover:!shadow-none">
              <td>width</td>
              <td>
                Applies to image link only - Specify the image width in pixels. Please choose a
                number between 100 and 1200.{' '}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="flex flex-col gap-y-4 border border-dashed border-gray-500 bg-gray-200 px-3 py-2">
        <div className="">
          <label className="block">
            Product Link (
            <label className="text-sm">Open house in Rendivo</label> )
          </label>

          <a
            href={`${baseUrl}/house/${product.id}`}
            target="_blank"
            rel="noreferrer"
          >
            {`${baseUrl}/house/${product.id}`}
          </a>
        </div>
        <div>
          <label className="block">Product Image Link</label>
          <a
            href={`${baseUrl}/product/${product.id}/image?width=600`}
            target="_blank"
            rel="noreferrer"
          >
            {`${baseUrl}/product/${product.id}/image?width=600`}
          </a>
        </div>

        <div>
          <label className="block">Product API Link</label>
          <a
            href={`${baseUrl}/v1/client/products/${product.id}`}
            target="_blank"
            rel="noreferrer"
          >
            {`${baseUrl}/product/${product.id}/image?width=600`}
          </a>
        </div>
      </div>
    </div>
  );
}
